import React from 'react';
import moment from 'moment';
import _ from 'underscore';

import FilterIcon from 'components/v2/icons/FilterIcon';
import Badge from 'components/v2/Badge';
import { humanize, titleize } from 'underscore.string';
import { useTranslation } from 'react-i18next';
import { getCustomerName } from './helpers';
import { sluggify } from 'utils/localization/utils';

/*
 * An active filters component
 */

export default function ActiveFilters({ query, onRemove, onClear }) {
  const active = [];
  const { t } = useTranslation();
  _.map(query, (value, key) => {
    if (value && value !== undefined) {
      if (key === 'window_start') {
        active.push({
          code: 1,
          component: (
            <Badge
              key={1}
              withRemove
              onRemove={() =>
                onRemove('window_start', { window_start: undefined })
              }
              color="blue"
            >
              {t('START_WITH_DATE', {
                date: moment(value).format('MM-DD-YYYY'),
              })}
            </Badge>
          ),
        });
      } else if (key === 'window_end') {
        active.push({
          code: 2,
          component: (
            <Badge
              key={2}
              withRemove
              onRemove={() => onRemove('window_end', { window_end: undefined })}
              color="blue"
            >
              {t('END_WITH_DATE', { date: moment(value).format('MM-DD-YYYY') })}
            </Badge>
          ),
        });
      } else if (key === 'yard') {
        value.forEach((l) => {
          active.push({
            code: 10,
            component: (
              <Badge
                key={10}
                withRemove
                onRemove={() => onRemove('yard_remove', value, l._id)}
                color="yellow"
              >
                {t('YARD_DATA', { yard: titleize(l.name) })}
              </Badge>
            ),
          });
        });
      } else if (key === 'status') {
        value.forEach((s) => {
          active.push({
            code: 20,
            component: (
              <Badge
                key={20}
                withRemove
                onRemove={() => onRemove('status_remove', value, s.slug)}
                color="purple"
              >
                {t('STATUS_WITH_VALUE', { status: s.localizedName ? s.localizedName : titleize(s.slug) })}
              </Badge>
            ),
          });
        });
      } else if (key === 'container_number') {
        value.forEach((c) => {
          active.push({
            code: 25,
            component: (
              <Badge
                key={25}
                withRemove
                onRemove={() => onRemove('container_remove', value, c)}
                color="yellow"
              >
                {t('CONTAINER_DATA', { container: c })}
              </Badge>
            ),
          });
        });
      } else if (key === 'master_bill_number') {
        value.forEach((m) => {
          active.push({
            code: 25,
            component: (
              <Badge
                key={`master_bill_number-${m}`}
                withRemove
                onRemove={() => onRemove('master_bill_remove', value, m)}
                color="yellow"
              >
                {t('MASTER_BILL_DATA', { m })}
              </Badge>
            ),
          });
        });
      } else if (key === 'consignee') {
        value.forEach((c) => {
          active.push({
            code: 30,
            component: (
              <Badge
                key={`consignee-${c._id}`}
                withRemove
                onRemove={() => onRemove('consignee_remove', value, c._id)}
                color="pink"
              >
                {t('CONSIGNEE_DATA', {
                  consignee: titleize(getCustomerName(c)),
                })}
              </Badge>
            ),
          });
        });
      } else if (key === 'shipper') {
        value.forEach((s) => {
          active.push({
            code: 40,
            component: (
              <Badge
                key={`shipper-${s._id}`}
                withRemove
                onRemove={() => onRemove('shipper_remove', value, s._id)}
                color="green"
              >
                {t('SHIPPER_DATA', { shipper: titleize(getCustomerName(s)) })}
              </Badge>
            ),
          });
        });
      } else if (key === 'carrier') {
        value.forEach((c) => {
          active.push({
            code: 50,
            component: (
              <Badge
                key={`carrier-${c._id}`}
                withRemove
                onRemove={() => onRemove('carrier_remove', value, c._id)}
                color="blue"
              >
                {t('CARRIER_DATA', { carrier: titleize(getCustomerName(c)) })}
              </Badge>
            ),
          });
        });
      } else if (key === 'sortBy') {
        active.push({
          code: 100,
          component: (
            <Badge
              key="sort_by_remove"
              withRemove
              onRemove={() => onRemove('sort_by_remove')}
              color="red"
            >
              {t('SORTED_BY_DATA', {
                value: t(sluggify(`${value} ${query.sortOrder.toUpperCase()}`)),
              })}
            </Badge>
          ),
        });
      }
    }
  });

  if (active && active.length > 0) {
    active.push({
      code: 150,
      component: (
        <button className="text-xs text-blue" onClick={onClear} key="clear-all">
          [{t('CLEAR_ALL_FILTERS')}]
        </button>
      ),
    });
  }

  const activeFilters = _.sortBy(active, 'code').map((a) => a.component);

  return (
    <div className="p-4">
      <div className="flex flex-wrap space-x-2 space-y-2">
        <FilterIcon className="mt-1 w-6 h-6 text-green" />
        <label className="form-label">{t('ACTIVE_FILTERS')}</label>
        {activeFilters}
      </div>
    </div>
  );
}
